import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUp } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { SortMode } from 'shared/hooks/use-data-grid-sorting';

import { LifeAreaColumnType } from '../../types';
import * as Styled from './life-area-sort-bar.style';

const columnLabels: Record<LifeAreaColumnType, string> = {
  [LifeAreaColumnType.Name]:
    'general.labels.life-area-table.headers.name.title',
  [LifeAreaColumnType.Vision]:
    'general.labels.life-area-table.headers.vision.title',
  [LifeAreaColumnType.Goals]:
    'general.labels.life-area-table.headers.goals.title',
  [LifeAreaColumnType.Projects]:
    'general.labels.life-area-table.headers.projects.title',
};

const rightColumns = [
  LifeAreaColumnType.Vision,
  LifeAreaColumnType.Goals,
  LifeAreaColumnType.Projects,
];

type SortColumnProps = {
  column: LifeAreaColumnType;
  isActive: boolean;
  sortMode: SortMode;
  onSelect: (column: LifeAreaColumnType) => void;
};

const SortColumn: React.FC<SortColumnProps> = ({
  column,
  isActive,
  sortMode,
  onSelect,
}) => {
  const { t } = useTranslation();
  const handleClick = () => onSelect(column);

  return (
    <Styled.Item $column={column}>
      <Styled.Button $active={isActive} onClick={handleClick}>
        <Typography variant="caption" component="span">
          {t(columnLabels[column])}
        </Typography>
        {isActive && (
          <Styled.DirectionIcon $desc={sortMode === SortMode.Desc}>
            <Icon icon={ArrowUp} />
          </Styled.DirectionIcon>
        )}
      </Styled.Button>
    </Styled.Item>
  );
};

export type LifeAreaSortBarProps = {
  column?: LifeAreaColumnType;
  sortMode: SortMode;
  onSortChange: (column: LifeAreaColumnType) => void;
};

export const LifeAreaSortBar: React.FC<LifeAreaSortBarProps> = ({
  column,
  sortMode,
  onSortChange,
}) => (
  <Styled.Container>
    <SortColumn
      column={LifeAreaColumnType.Name}
      isActive={column === LifeAreaColumnType.Name}
      sortMode={sortMode}
      onSelect={onSortChange}
    />

    <Styled.RightGroup>
      {rightColumns.map((rightColumn) => (
        <SortColumn
          key={rightColumn}
          column={rightColumn}
          isActive={column === rightColumn}
          sortMode={sortMode}
          onSelect={onSortChange}
        />
      ))}
    </Styled.RightGroup>
  </Styled.Container>
);
